import Image from "next/image";
import styles from "./WishlistToast.module.scss";
import Button from "@components/atoms/Button";
import Text from "@components/atoms/Text";
import assetLoader from "@utils/internalImageLoder";

interface WishlistToastProps {
  isVisible: boolean;
  isAdding: boolean;
  carMake: string;
  carName: string;
  hasBottomNav: boolean;
  onViewWishlist: () => void;
  onUndo: () => void;
}

const WishlistToast = ({
  isVisible,
  isAdding,
  carMake,
  carName,
  hasBottomNav,
  onViewWishlist,
  onUndo,
}: WishlistToastProps) => {
  if (!isVisible) return null;

  return (
    <div
      className={`${styles.wishlistToast} ${
        hasBottomNav ? styles.hasBottomNav : styles.hasNotBottomNav
      }`}
    >
      <div className={styles.wishlistToast_iconText}>
        <Image
          src={
            isAdding
              ? `${assetLoader()}/icons/checked_light.svg`
              : `${assetLoader()}/icons/alert_error_info.svg`
          }
          alt={isAdding ? "Added to wishlist" : "Removed from wishlist"}
          width={20}
          height={20}
          loading="lazy"
        />
        <Text className={styles.wishlistToast_text}>
          {carMake} {carName} {isAdding ? "added to" : "removed from"} your
          wishlist
        </Text>
      </div>
      <Button
        className={`${styles.wishlistToast_button} ${
          !isAdding ? styles.undo : ""
        }`}
        onButtonClick={isAdding ? onViewWishlist : onUndo}
        ariaLabel={isAdding ? "View wishlist" : "Undo remove from wishlist"}
      >
        {isAdding ? "View" : "Undo"}
      </Button>
    </div>
  );
};

export default WishlistToast;
